export const isEmptyArray = (array?: any[]): boolean => {
    if (!array) return true
    else return array?.length === 0
}

export const isNotEmptyArray = (array?: any[]): boolean => {
    return !isEmptyArray(array)
}
